import React from 'react';
import './footernav.css'

const Navfooter = (props) => {
    return ( 
        <li className='footernavss'>{props.title}</li>
     );
}
 
export default Navfooter;